import { UNIT_BOX, UNIT_PACKET, UNIT_PIECE } from "./common";
import type { PackDef } from "./types";

export const ELECTRONICS_PACK: PackDef = {
  id: "electronics",
  version: 1,
  available: true,
  name: { en: "Mobile & electronics", bn: "মোবাইল ও ইলেকট্রনিক্স" },
  description: {
    en: "Phone, computer and appliance shops that record IMEI or serial numbers and warranties",
    bn: "IMEI বা সিরিয়াল নম্বর ও ওয়ারেন্টি রাখা মোবাইল, কম্পিউটার ও ইলেকট্রনিক্সের দোকান",
  },
  icon: "smartphone",
  modules: {
    variants: true,
    batches: false,
    expiry: false,
    serials: true,
    vat: false,
    multi_branch: false,
    storefront: false,
    loans: false,
  },
  baseUnits: [
    UNIT_PIECE,
    UNIT_BOX,
    UNIT_PACKET,
    { code: "set", name: { en: "Set", bn: "সেট" }, fractional: false },
    { code: "pair", name: { en: "Pair", bn: "জোড়া" }, fractional: false },
    { code: "m", name: { en: "Metre", bn: "মিটার" }, fractional: true },
  ],
  unitConversions: [],
  categories: [
    { en: "Mobile phones", bn: "মোবাইল ফোন" },
    { en: "Feature phones", bn: "বাটন ফোন" },
    { en: "Tablets", bn: "ট্যাবলেট" },
    { en: "Laptops & computers", bn: "ল্যাপটপ ও কম্পিউটার" },
    { en: "Chargers & cables", bn: "চার্জার ও ক্যাবল" },
    { en: "Power banks", bn: "পাওয়ার ব্যাংক" },
    { en: "Headphones & speakers", bn: "হেডফোন ও স্পিকার" },
    { en: "Covers & protectors", bn: "কভার ও প্রটেক্টর" },
    { en: "Smart watches", bn: "স্মার্ট ওয়াচ" },
    { en: "TV & appliances", bn: "টিভি ও হোম অ্যাপ্লায়েন্স" },
    { en: "Fans & lights", bn: "ফ্যান ও লাইট" },
    { en: "Repairs & services", bn: "মেরামত ও সার্ভিস" },
  ],
  customFields: [
    {
      key: "model",
      entity: "item",
      type: "text",
      label: { en: "Model", bn: "মডেল" },
      required: false,
      searchable: true,
    },
    {
      key: "condition",
      entity: "item",
      type: "select",
      label: { en: "Condition", bn: "অবস্থা" },
      required: false,
      searchable: false,
      options: [
        { value: "new", label: { en: "New", bn: "নতুন" } },
        { value: "used", label: { en: "Used", bn: "ব্যবহৃত" } },
        { value: "refurbished", label: { en: "Refurbished", bn: "রিফার্বিশড" } },
      ],
    },
    {
      key: "warranty_type",
      entity: "item",
      type: "select",
      label: { en: "Warranty from", bn: "ওয়ারেন্টি" },
      required: false,
      searchable: false,
      options: [
        { value: "official", label: { en: "Official (brand)", bn: "অফিসিয়াল (ব্র্যান্ড)" } },
        { value: "shop", label: { en: "Shop", bn: "দোকান" } },
        { value: "none", label: { en: "No warranty", bn: "ওয়ারেন্টি নেই" } },
      ],
    },
  ],
  variantPresets: [
    { name: { en: "Storage", bn: "স্টোরেজ" }, values: ["64GB", "128GB", "256GB", "512GB"] },
    { name: { en: "RAM", bn: "র‍্যাম" }, values: ["4GB", "6GB", "8GB", "12GB"] },
    { name: { en: "Colour", bn: "রং" }, values: ["Black", "White", "Blue", "Green", "Gold"] },
  ],
  defaultWarrantyMonths: 12,
  receiptTemplate: "retail",
  dashboard: [
    "sales_today",
    "gross_profit",
    "cash_in_hand",
    "dues_receivable",
    "dues_payable",
    "low_stock",
    "sales_trend",
  ],
};
